import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock } from 'lucide-react';
export function ClosingCTA() {
  return <Section background="warm" id="checkout" data-id="element-32">
      <FadeIn data-id="element-33">
        <div className="text-center max-w-2xl mx-auto" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 font-serif" data-id="element-35">
            Empezá hoy mismo
          </h2>

          <p className="text-xl text-gray-700 mb-10 leading-relaxed" data-id="element-36">
            La pregunta no es si tu rodilla "algún día" va a mejorar. La
            pregunta es si vas a seguir negociando con ella salida por salida… o
            si vas a empezar a construir una rodilla más confiable con un plan
            que no te traicione.
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-xl border border-[#D8F3DC] mb-8" data-id="element-37">
            <div className="mb-6" data-id="element-38">
              <span className="inline-block bg-red-100 text-red-700 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3" data-id="element-39">
                Oferta especial
              </span>
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-40">
                <span className="text-2xl text-gray-400 line-through font-medium" data-id="element-41">
                  $18.600
                </span>
              </div>
              <div className="text-5xl font-bold text-[#1B4332] mt-1" data-id="element-42">
                $9.300
                <span className="text-xl text-gray-400 font-normal ml-1" data-id="element-43">
                  ARS
                </span>
              </div>
              <p className="text-sm text-[#40916C] font-semibold mt-2" data-id="element-44">
                50% de descuento — por tiempo limitado
              </p>
            </div>

            <Button size="lg" className="w-full md:w-auto min-w-[280px] mb-4" data-id="element-45">
              Accedé ahora a Rodilla Sin Miedo
            </Button>

            <div className="flex flex-col gap-2 text-sm text-gray-500 mt-4" data-id="element-46">
              <div className="flex items-center justify-center gap-2" data-id="element-47">
                <Lock className="h-4 w-4" data-id="element-48" />
                <span data-id="element-49">Pago 100% Seguro</span>
              </div>
              <p data-id="element-50">PDF descargable al instante • Rutina 10–12 min</p>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}